module.exports = __webpack_public_path__ + "static/media/checkmark.d87250c6.svg";